var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SHOP_PAYMENT_SETTINGS = exports.GET_SHOP_SETTINGS = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.GET_SHOP_SETTINGS = (0, graphql_tag_1.default) `
  query GET_SHOP_SETTINGS {
    shop {
      name
      description
      moneyFormat
      primaryDomain {
        host
        url
      }
      shipsToCountries
      paymentSettings {
        acceptedCardBrands
        countryCode
        currencyCode
        enabledPresentmentCurrencies
        supportedDigitalWallets
      }
    }
  }
`;
exports.GET_SHOP_PAYMENT_SETTINGS = (0, graphql_tag_1.default) `
  query GET_SHOP_PAYMENT_SETTINGS {
    shop {
      paymentSettings {
        acceptedCardBrands
        countryCode
        currencyCode
        enabledPresentmentCurrencies
        supportedDigitalWallets
      }
    }
  }
`;
//# sourceMappingURL=shop.js.map